import { render, staticRenderFns } from "./InfiniteScrollWrapper.vue?vue&type=template&id=5051caf1&"
import script from "./InfiniteScrollWrapper.vue?vue&type=script&lang=js&"
export * from "./InfiniteScrollWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports